import CookieService from "encrypted-cookie";
import { baseUrls } from "./apiEndpoints/Endpoints";
import { env } from "./environment";
import axios from "axios";
export const setCookie = (key, value, expires) => {
  CookieService.setCookie(key, JSON.stringify(value), expires);
  return;
};

//invalidates cookies by setting expiry to a past date
export const inValidateCookies = (clearAll) => {
  const allCookies = document.cookie;

  allCookies?.split(";").forEach((keyValuePair) => {
    const key = keyValuePair.split("=")[0]?.trim();

    //leave out refreshToken if clearAll is false
    if (clearAll || key !== "refreshToken") CookieService.eraseCookie(key);
  });
};

export const startSession = async (jwt) => {
  const {
    refreshToken,
    accessToken,
    expiresIn,
    expiresAt,
    refreshAt,
  } = jwt;

  //expiration in expressed in days (because the library takes only days)
  let expiration = expiresIn / 3600 / 24;

  setCookie(expiration, true);

  setCookie(
    "cachedJwt",
    { accessToken, expiresIn, expiresAt, refreshAt },
    expiration,
    true
  );
  if (refreshToken) {
    setCookie("refreshToken", refreshToken, expiration);
  }

  const { userInfo } = await user_cookies_setup(accessToken);
  setCookie("userInfo", userInfo)
  return;
};

export const getCookie = (searchKey) => {
  let cookieValue = CookieService.getCookie(searchKey);
  if (cookieValue) {
    return JSON.parse(cookieValue);
  } else {
    return null;
  }
};
export const user_cookies_setup = async (accessToken) => {
  let baseUrl = baseUrls[env];
  let user = await axios({
    url: baseUrl + `Admin/User/Profile`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "X-UserId": 0,
      "X-LiveMode": env == "prod" ? true : false,
    },
  })
    .then(async (res) => {
      const resData = res.data || {};
          const userInfo = {
        userId: resData.userId,
        email: resData.email,
        given_name: resData.givenName,
        family_name: resData.familyName,
        userStatus: resData.status,
      };

      return {userInfo};
    })
    .catch(() => {
      return { userInfo: { error: true }};
    });

  return user;
};
